import { render } from "./EditVoucher.vue?vue&type=template&id=11bba4d0"
import script from "./EditVoucher.vue?vue&type=script&lang=js"
export * from "./EditVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__